import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's own page parts, which the
// package entry must not pull in.
const Page = lazy(() => import("./SsoPage").then((m) => ({ default: m.SsoPage })));

export const SsoRoute = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

// A tab of the Organization page, with the other rules about who gets in.
export const ssoTab = {
  key: "sso",
  label: "Single sign-on",
  path: "/sso",
  component: SsoRoute,
  when: "admin",
  after: "access",
};

const Platform = lazy(() => import("./PlatformSignIn").then((m) => ({ default: m.PlatformSignIn })));

// A tab of the Platform page: the sign-in buttons everyone sees.
export const platformSignInTab = {
  key: "sign-in",
  label: "Sign-in",
  path: "/platform/sign-in",
  after: "product",
  component: (props) => (
    <Suspense fallback={null}>
      <Platform {...props} />
    </Suspense>
  ),
};
